import { css } from "../../../../../styled-system/css";
import { t } from "../../../../libs/i18n";
import { Heading } from "./heading";

export const ShigaOtsuCampaignDetail = () => {
  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: "36px",
      })}
    >
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        })}
      >
        <Heading>{t("ポイント新規登録キャンペーンについて")}</Heading>
        <p
          className={css({
            fontSize: "16px",
            lineHeight: "1.5",
            letterSpacing: "0.16px",
            color: "text.primary",
          })}
        >
          {t(
            "ポイントミニアプリに新規登録すると、おひとりさま1回限りで300ポイントがその場で付与されます。",
          )}
        </p>
      </div>

      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        })}
      >
        <Heading>{t("応募の方法")}</Heading>
        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          })}
        >
          <div
            className={css({
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            })}
          >
            <h3
              className={css({
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "1.5",
                letterSpacing: "0.16px",
                color: "text.primary",
              })}
            >
              {t("STEP1：応募ボタンをタップ")}
            </h3>
            <p
              className={css({
                fontSize: "16px",
                lineHeight: "1.5",
                letterSpacing: "0.16px",
                color: "text.primary",
              })}
            >
              {t(
                "「ポイント」アプリのホーム画面から、「応募する」ボタンを押します。",
              )}
            </p>
          </div>

          <div
            className={css({
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            })}
          >
            <h3
              className={css({
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "1.5",
                letterSpacing: "0.16px",
                color: "text.primary",
              })}
            >
              {t("STEP2：応募手続きを完了")}
            </h3>
            <p
              className={css({
                fontSize: "16px",
                lineHeight: "1.5",
                letterSpacing: "0.16px",
                color: "text.primary",
              })}
            >
              {t(
                "案内にしたがって応募を完了すると、即時で300ポイントが付与されます。",
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
